import { useSelector } from "react-redux";

import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";

import ProfileCredentials from "./credentials.component";

const ProfileCredentialsContainer = () => {
    const customer = useSelector(getCustomer);

    return <>{customer && <ProfileCredentials />}</>;
};

export { ProfileCredentialsContainer };
